import { getApiGalaxyServer } from 'services';

/**
 * A cohort is a shared-DB-cluster pool (Enterprise "group filling", RDM-2031).
 * The picker endpoint returns ACTIVE Enterprise cohorts only, least-filled first;
 * full cohorts are included so the picker can render them disabled with X/Y.
 */
export interface Cohort {
  id: number;
  cohortId: string;
  applicationClusterSecret: string;
  integrationClusterSecret: string | null;
  capacityLimit: number;
  currentCount: number;
  region: string;
  status: string;
  createdAt: string;
}

export const cohortHasRoom = (cohort: Cohort) => cohort.currentCount < cohort.capacityLimit;

/**
 * GET /tenant/cohorts — the group-filling picker list (GLX-1863).
 */
export const getCohortsApi = ({ token, config = {} }: BaseApiParams<void>) => {
  return getApiGalaxyServer<Cohort[]>(`/tenant/cohorts`, config, token);
};
